var _g, _defs, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSastirideLogoAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.683,11.683)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 226.63418818012875 226.63418818012875",
    height: 226.63418818012875,
    width: 226.63418818012875,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", {
    id: "icon-0"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 226.63418818012875 226.63418818012875",
    height: 226.63418818012875,
    width: 226.63418818012875,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 113.317c0-62.583 50.734-113.317 113.317-113.317 62.583 0 113.317 50.734 113.317 113.317 0 62.583-50.734 113.317-113.317 113.317-62.583 0-113.317-50.734-113.317-113.317zM113.317 219.387c58.581 0 106.07-47.489 106.07-106.07 0-58.581-47.489-106.07-106.07-106.07-58.581 0-106.07 47.489-106.07 106.07 0 58.581 47.489 106.07 106.07 106.07z",
    "data-fill-palette-color": "accent",
    fill: "#000000",
    stroke: "transparent"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0s",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.62571020950803,46.95612122041136)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 127.38276776111269 132.72194573930602",
    height: 132.72194573930602,
    width: 127.38276776111269,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "2.85 1.628693936277085 58.3 60.743612127445836",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    height: 132.72194573930602,
    width: 127.38276776111269,
    className: "icon-dxe-0",
    "data-fill-palette-color": "accent",
    id: "dxe-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-arrow-up"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 65,
    width: 65,
    height: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 65,
    to: 0,
    dur: "0.9s",
    begin: "0.85s",
    fill: "freeze",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.4 0 0.2 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 65,
    dur: "0.9s",
    begin: "0.85s",
    fill: "freeze",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.4 0 0.2 1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-arrow-down"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 65,
    height: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 65,
    dur: "0.9s",
    begin: "2.1s",
    fill: "freeze",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.4 0 0.2 1"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.74 36.46C6.389 36.46 2.85 39.999 2.85 44.35 2.85 47.045 4.056 50.573 6.436 54.837A59 59 0 0 0 9.997 60.394C10.19 60.623 10.483 60.76 10.78 60.76 11.104 60.76 11.404 60.602 11.6 60.326L11.596 60.322C11.979 59.786 13.603 57.235 15.101 54.414 17.463 50.008 18.66 46.622 18.66 44.35 18.66 39.999 15.121 36.46 10.74 36.46M13.32 44.53A2.563 2.563 0 0 1 10.76 47.09 2.563 2.563 0 0 1 8.2 44.53 2.57 2.57 0 0 1 10.76 41.96 2.57 2.57 0 0 1 13.32 44.53",
    fill: "#000000",
    "data-fill-palette-color": "accent"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.1s",
    begin: "0.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0,-20;0,2;0,-1;0,0",
    keyTimes: "0;0.55;0.8;1",
    dur: "0.6s",
    begin: "0.5s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.2 0 0.4 1;0.4 0 0.6 1;0.4 0 0.6 1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-arrow-up)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7 32.75A0.75 0.75 0 0 0 10.45 32C10.45 19.447 21.919 9.161 36.292 8.531L32.68 14.113A0.75 0.75 0 1 0 33.94 14.927L38.321 8.157C38.333 8.138 38.334 8.117 38.344 8.098 38.358 8.071 38.375 8.048 38.386 8.019 38.397 7.992 38.4 7.964 38.407 7.936A1 1 0 0 0 38.428 7.811C38.43 7.79 38.441 7.771 38.441 7.749 38.441 7.743 38.438 7.738 38.438 7.732 38.437 7.705 38.429 7.68 38.425 7.653A1 1 0 0 0 38.396 7.525C38.387 7.499 38.386 7.471 38.375 7.447 38.365 7.425 38.348 7.407 38.336 7.386A1 1 0 0 0 38.262 7.279C38.242 7.256 38.229 7.23 38.206 7.209 38.202 7.205 38.201 7.199 38.196 7.195L32.316 1.825A0.75 0.75 0 0 0 31.304 2.933L35.821 7.058C20.842 7.9 8.95 18.762 8.95 32 8.95 32.414 9.286 32.75 9.7 32.75",
    fill: "#000000",
    "data-fill-palette-color": "accent"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.23 1.95C48.879 1.95 45.339 5.489 45.339 9.84 45.339 12.553 46.545 16.081 48.925 20.328 50.422 22.991 52.015 25.249 52.426 25.794A0.98 0.98 0 0 0 53.259 26.25H53.269C53.587 26.25 53.893 26.089 54.088 25.819 54.112 25.784 54.129 25.766 54.148 25.728A83 83 0 0 0 57.59 19.903C59.952 15.48 61.15 12.094 61.15 9.84 61.15 5.489 57.61 1.95 53.23 1.95M55.8 10.01A2.57 2.57 0 0 1 53.24 12.58 2.57 2.57 0 0 1 50.679 10.01 2.563 2.563 0 0 1 53.24 7.45 2.564 2.564 0 0 1 55.8 10.01",
    fill: "#000000",
    "data-fill-palette-color": "accent"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.1s",
    begin: "1.75s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0,-20;0,2;0,-1;0,0",
    keyTimes: "0;0.55;0.8;1",
    dur: "0.6s",
    begin: "1.75s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.2 0 0.4 1;0.4 0 0.6 1;0.4 0 0.6 1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-arrow-down)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3 31.25A0.75 0.75 0 0 0 53.55 32C53.55 44.554 42.081 54.839 27.709 55.47L31.32 49.888A0.75 0.75 0 1 0 30.06 49.074L25.68 55.844C25.668 55.863 25.667 55.884 25.657 55.904 25.643 55.93 25.626 55.954 25.615 55.982S25.601 56.037 25.594 56.064A1 1 0 0 0 25.573 56.19C25.572 56.211 25.561 56.23 25.561 56.252 25.561 56.258 25.564 56.263 25.564 56.269 25.564 56.295 25.573 56.321 25.576 56.346A1 1 0 0 0 25.606 56.477C25.614 56.502 25.615 56.53 25.626 56.554 25.636 56.575 25.653 56.593 25.665 56.615A1 1 0 0 0 25.74 56.722C25.759 56.745 25.773 56.772 25.795 56.792L25.805 56.806 31.685 62.176A0.748 0.748 0 1 0 32.697 61.068L28.18 56.943C43.158 56.1 55.05 45.238 55.05 32A0.75 0.75 0 0 0 54.3 31.25",
    fill: "#000000",
    "data-fill-palette-color": "accent"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSastirideLogoAnimated);
export default __webpack_public_path__ + "static/media/sastiride-logo-animated.4140e99cb4693dc116c0cfb37c6ac137.svg";
export { ForwardRef as ReactComponent };